import { createSlice,createSelector } from "@reduxjs/toolkit";

const initialState = {}; // Generic store

const genericSlice = createSlice({
  name: "generic",
  initialState,
  reducers: {
    setData: (state, action) => {
      const { key, value } = action.payload;
      return {
        ...state, // Create a new object reference
        [key]: value, // Store new data
      };
    },
    resetData: (state, action) => {
      const { key } = action.payload;
      if (key) {
        return {
          ...state,
          [key]: [], // Reset only the specific key
        };
      }
      return {}; // Reset entire store
    },
  },
});

export const { setData, resetData } = genericSlice.actions;

// **Memoized Selector to Prevent Unnecessary Rerenders**
// export const selectGenericData = (state, key) => state.generic[key] || [];

export const selectGenericData = createSelector(
  (state) => state.generic,
  (_, key) => key,
  (generic, key) => generic[key] || []
);

export default genericSlice.reducer;
